// AdminWidgetsSpec.staff-renders.js — 직원 그룹 회사별 공통 render 함수 (2026-06-08)
//
// 회사별 fan-out 위젯에서 사용되는 render 함수를 별도 파일로 분리 (circular import 방지).
// .staff.js 와 .staff-companies.js 가 모두 본 파일을 import.

import React, { useState } from 'react';
import { formatCompactKrw } from './widgetFormat';
import { apiClient } from '../../../api/apiClient';

const ATTN = 'text-amber-700';
const ATTN_BG = 'bg-amber-50';

// 급여 재계산 버튼
function PayrollRecalcButton({ month, companyCode = 'PINE', label = '재계산' }) {
  const [busy, setBusy] = useState(false);
  const handleClick = async (e) => {
    e.stopPropagation();
    if (busy) return;
    setBusy(true);
    const ym = month || '';
    const [y, m] = ym.split('-').map(Number);
    if (!y || !m) { setBusy(false); return; }
    await apiClient.post('/api/admin/payroll/monthly/calculate', {
      company_code: companyCode, year: y, month: m,
    });
    window.location.reload();
  };
  return (
    <button
      type="button"
      onClick={handleClick}
      onPointerDown={(e) => e.stopPropagation()}
      disabled={busy}
      className="text-[10px] font-bold text-violet-700 dark:text-violet-300 px-2 py-0.5 rounded border border-violet-300 hover:bg-violet-50 disabled:opacity-50 whitespace-nowrap"
    >
      {busy ? '계산 중...' : label}
    </button>
  );
}

// 4. 월 급여 총액 — 회사별 fan-out (data.companyCode 로 재계산 분기)
export function renderPayrollMonthTotal(d) {
  if (!d) return '-';
  const cc = d.companyCode || 'PINE';
  if (Number(d.recordCount || 0) === 0) {
    return (
      <span className="flex flex-col items-end gap-1">
        <span className={`text-[10px] ${ATTN} font-semibold`}>미생성</span>
        <PayrollRecalcButton month={d.month} companyCode={cc} />
      </span>
    );
  }
  const txt = formatCompactKrw(d.total);
  return (
    <span className="flex flex-col items-end gap-1 max-w-full">
      <span className="text-xl font-black tabular-nums leading-none text-violet-700 dark:text-violet-300 whitespace-nowrap">
        {txt}
      </span>
      {d.allConfirmed ? (
        <span className="text-[10px] text-[var(--text-muted)]">확정</span>
      ) : (
        <PayrollRecalcButton month={d.month} companyCode={cc} />
      )}
    </span>
  );
}

// 5. 월 인센티브 총액 — 회사별 fan-out
export function renderIncentiveMonthTotal(d) {
  if (!d) return '-';
  return (
    <span className="flex flex-col items-end max-w-full">
      <span className="text-xl font-black tabular-nums leading-none text-pink-700 dark:text-pink-300 whitespace-nowrap">
        {formatCompactKrw(d.total)}
      </span>
    </span>
  );
}

// 3. 다가오는 계약 갱신 — 회사별 fan-out
export function renderRenewal(d) {
  if (!d) return '-';
  const up = Array.isArray(d.upcoming) ? d.upcoming : [];
  const ov = Array.isArray(d.overdue) ? d.overdue : [];
  const fmtD = (ymd) => {
    const [, m, dd] = ymd.split('-');
    return `${Number(m)}/${Number(dd)}`;
  };
  if (up.length === 0 && ov.length === 0) {
    return <span className="text-[10px] text-[var(--text-muted)]">없음</span>;
  }
  return (
    <span className="flex flex-col items-end gap-1">
      <span className="text-xl font-black tabular-nums leading-none">
        {ov.length > 0 && (
          <span className={`${ATTN} mr-1`}>지남 {ov.length}</span>
        )}
        <span className="text-indigo-700 dark:text-indigo-300">예정 {up.length}</span>
      </span>
      <span className="flex flex-wrap gap-x-1.5 gap-y-0.5 justify-end items-center">
        {ov.slice(0, 2).map((p, i) => (
          <span
            key={`ov-${i}`}
            className={`text-[10px] px-1 py-px rounded ${ATTN_BG} ${ATTN} font-semibold`}
            title="갱신일 지남"
          >
            ⚠ {fmtD(p.date)} {p.name}
          </span>
        ))}
        {up.slice(0, 2).map((p, i) => (
          <span key={`up-${i}`} className="text-[10px] text-[var(--text-main)]">
            {fmtD(p.date)} {p.name}
          </span>
        ))}
      </span>
    </span>
  );
}

export const monthLabel = (m) => {
  if (!m) return '';
  const [, mm] = String(m).split('-');
  if (!mm) return '';
  return `${Number(mm)}월`;
};
